var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DEFAULT_SWIPER_CONFIG = {
    direction: 'horizontal',
    slidesPerView: 'auto'
};
import 'hammerjs';
var AppWindow = /** @class */ (function (_super) {
    __extends(AppWindow, _super);
    function AppWindow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AppWindow;
}(Window));
export { AppWindow };
;
var ɵ0 = DEFAULT_SWIPER_CONFIG;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
// WEBPACK FOOTER //
// ./src/app/app.module.ts



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js